import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { takeNext } from "@/lib/utils";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { apiError, pendingSignup } from "@/components/home/homeData";

// Handles the return from Emergent Google login: reads #session_id=... from the
// URL fragment and exchanges it (or creates a new company if the user came from
// company sign-up), then routes into the app. Ref guard: runs once under StrictMode.
export const AuthCallback = () => {
  const { completeGoogleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    const signup = pendingSignup.take();
    (async () => {
      if (sid) {
        try {
          const u = await completeGoogleSession(sid, signup);
          toast.success(signup ? `Welcome to Cross Jobs, ${(u?.name || "").split(" ")[0] || "there"}` : "Signed in with Google");
        } catch (err) {
          toast.error(signup ? apiError(err, "Could not create your company — please try again.") : "Google sign-in failed — please try again");
          navigate(signup && err?.response?.status !== 409 ? "/home" : "/login", { replace: true });
          return;
        }
      }
      navigate(takeNext(), { replace: true });
    })();
  }, [completeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
};
